<template>
  <div>
    <p>语音点评</p>
    <p>时长： {{ duration }}</p>
    <button @click="start">
      开始
    </button>
    <button @click="stop">
      停止
    </button>
    <button @click="play">
      播放录音
    </button>
    <button @click="playMp3">
      播放mp3
    </button>
    <button @click="upload">
      上传
    </button>
    <audio
      v-if="mp3Url"
      controls
      :src="mp3Url"
    >
      Your browser does not support the
      <code>audio</code> element.
    </audio>
  </div>
</template>
<script>
import Recorder from 'js-audio-recorder'
import lamejs from 'lamejs'
export default {
  data() {
    return {
      recorder: null,
      duration: null,
      isDenied: false,
      mp3Url: null
    }
  },
  created() {
    const recorder = new Recorder()
    this.recorder = recorder
    recorder.onprogress = params => {
      const { duration } = params
      this.duration = duration
      console.log('录音时长(秒)', duration)
      console.log('录音大小(字节)', params.fileSize)
      console.log('录音音量百分比(%)', params.vol)
      // console.log('当前录音的总数据([DataView, DataView...])', params.data);
    }
  },
  methods: {
    start() {
      if (this.isDenied) {
        alert('请开启麦克风权限并刷新页面')
        return
      }
      this.recorder.start().then(() => {
        // 开始录音
        console.log('开始录音')
      }, error => {
        // 出错了
        console.log(error)
        console.log(`${error.name} : ${error.message}`)
        if (error.message.indexOf('Permission denied') !== -1) {
          this.isDenied = true
        }
      })
    },
    stop() {
      this.recorder.stop()
    },
    play() {
      const { recorder } = this
      recorder && recorder.play()
    },
    playMp3() {
      const { recorder } = this
      if (!recorder) {
        return
      }
      const mp3Blob = this.convertToMp3(recorder.getWAV())
      console.log(mp3Blob)
      this.mp3Url = URL.createObjectURL(mp3Blob)
    },
    // https://github.com/2fps/recorder/issues/33 支持mp3
    // 请用 16位的采样位数
    convertToMp3(wavDataView) {
      const { recorder } = this
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView) // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const { channels, sampleRate } = wav
      console.log('wav', wav)
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128)
      // 获取左右通道数据
      const result = recorder.getChannelData()
      const buffer = []

      const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2)
      const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2)
      const remaining = leftData.length + (rightData ? rightData.length : 0)

      const maxSamples = 1152
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples)
        let right = null
        let mp3buf = null

        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples)
          mp3buf = mp3enc.encodeBuffer(left, right)
        } else {
          mp3buf = mp3enc.encodeBuffer(left)
        }

        if (mp3buf.length > 0) {
          buffer.push(mp3buf)
        }
      }

      const enc = mp3enc.flush()

      if (enc.length > 0) {
        buffer.push(enc)
      }

      return new Blob(buffer, { type: 'audio/mp3' })
    },
    async upload() {
      const { recorder } = this
      if (!recorder) {
        return
      }
      const mp3Blob = this.convertToMp3(recorder.getWAV())
      const file = new File([mp3Blob], `xkh-record-${new Date().getTime()}.mp3`, { type: 'audio/mp3' })
      const res = await this.$axxUpload.uploadFilesToAxx(file, (progressEvent, sign) => {
        console.log(sign, progressEvent)
      })
      console.log(res)
    }
  }
}
</script>